import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon';

export const AttentionIcon: ComponentWithAs<'svg', IIconProps> = (
  props: any,
) => (
  <Icon
    data-testid="warning-rounded-icon"
    width="13px"
    height="12px"
    viewBox="0 0 13 12"
    fill="none"
    {...props}
  >
    <path
      d="M6.99991 4.50002C6.99991 4.77617 6.77605 5.00002 6.49991 5.00002C6.22377 5.00002 5.99991 4.77617 5.99991 4.50002C5.99991 4.22388 6.22377 4.00002 6.49991 4.00002C6.77605 4.00002 6.99991 4.22388 6.99991 4.50002Z"
      fill="currentColor"
    />
    <path
      d="M6.49991 5.87502C6.70702 5.87502 6.87491 6.04292 6.87491 6.25002V8.75002C6.87491 8.95713 6.70702 9.12502 6.49991 9.12502C6.2928 9.12502 6.12491 8.95713 6.12491 8.75002V6.25002C6.12491 6.04292 6.2928 5.87502 6.49991 5.87502Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.63508 1.99634C7.0891 1.19751 5.9107 1.19751 5.36471 1.99634L5.14875 2.31231C3.79573 4.29192 2.63325 6.39523 1.67689 8.59407L1.63178 8.69778C1.29475 9.47266 1.80393 10.3525 2.64371 10.4464C5.20652 10.7328 7.79327 10.7328 10.3561 10.4464C11.1959 10.3525 11.705 9.47266 11.368 8.69778L11.3229 8.59407C10.3665 6.39523 9.20406 4.29192 7.85104 2.31232L7.63508 1.99634ZM5.98391 2.41955C6.23208 2.05644 6.76771 2.05644 7.01589 2.41955L7.23185 2.73552C8.55815 4.67603 9.69767 6.7378 10.6351 8.8932L10.6803 8.99691C10.816 9.30893 10.6109 9.66322 10.2728 9.70101C7.76533 9.98126 5.23446 9.98126 2.72701 9.70101C2.38886 9.66322 2.18383 9.30893 2.31954 8.99691L2.36465 8.89321C3.30213 6.7378 4.44165 4.67603 5.76795 2.73552L5.98391 2.41955Z"
      fill="currentColor"
    />
  </Icon>
);
